module.exports = __webpack_public_path__ + "img/dial_pointer.9977e0ee.png";